import React from "react";
import { Link } from "react-router-dom";

// Renders optional rich H2 content sections that pages can define in their
// data as `extraSections: [{ h2, body }]`, where each `body` item (paragraph)
// is either a string OR an array of segments (string | { to, label }) so
// internal links can sit naturally inside the copy.
const Segment = ({ seg }) =>
  typeof seg === "string" ? (
    <>{seg}</>
  ) : (
    <Link
      to={seg.to}
      className="text-[#E11D26] hover:text-white underline underline-offset-2 font-semibold transition-colors"
    >
      {seg.label}
    </Link>
  );

const Paragraph = ({ para }) => {
  const segs = Array.isArray(para) ? para : [para];
  return (
    <p className="mt-4 text-white/80 leading-relaxed text-base sm:text-lg">
      {segs.map((s, i) => (
        <Segment key={i} seg={s} />
      ))}
    </p>
  );
};

const ContentSections = ({ sections }) => {
  if (!sections || !sections.length) return null;
  return (
    <section className="py-14 md:py-16 bg-black border-b border-white/10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-10">
        {sections.map((sec, i) => (
          <div key={i} data-testid={`content-section-${i}`}>
            <h2
              className="text-2xl sm:text-3xl font-black text-white uppercase leading-tight"
              style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
            >
              {sec.h2}
            </h2>
            {sec.body.map((para, j) => (
              <Paragraph key={j} para={para} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContentSections;
